var items = {
  "block.minecraft.air": "αέρας",
  "block.minecraft.stone": "πέτρα",
  "block.minecraft.granite": "γρανίτης",
  "block.minecraft.polished_granite": "γυαλισμένος γρανίτης",
  "block.minecraft.diorite": "διορίτης",
  "block.minecraft.polished_diorite": "γυαλισμένος διορίτης",
  "block.minecraft.andesite": "ανδεσίτης",
  "block.minecraft.polished_andesite": "γυαλισμένος ανδεσίτης",
  "block.minecraft.grass_block": "κύβος γρασιδιού",
  "block.minecraft.dirt": "χώμα",
  "block.minecraft.coarse_dirt": "άγονο χώμα",
  "block.minecraft.podzol": "ποντσόλ",
  "block.minecraft.crimson_nylium": "ερυθρό νύλιο",
  "block.minecraft.warped_nylium": "διαστρεβλωμένο νύλιο",
  "block.minecraft.cobblestone": "κροκάλα",
  "block.minecraft.oak_planks": "σανίδες βελανιδιάς",
  "block.minecraft.spruce_planks": "σανίδες ελάτου",
  "block.minecraft.birch_planks": "σανίδες σημύδας",
  "block.minecraft.jungle_planks": "σανίδες ζούγκλας",
  "block.minecraft.acacia_planks": "σανίδες ακακίας",
  "block.minecraft.dark_oak_planks": "σανίδες σκούρας βελανιδιάς",
  "block.minecraft.crimson_planks": "ερυθρές σανίδες",
  "block.minecraft.warped_planks": "διαστρεβλωμένες σανίδες",
  "block.minecraft.oak_sapling": "βλαστάρι βελανιδιάς",
  "block.minecraft.spruce_sapling": "βλαστάρι ελάτου",
  "block.minecraft.birch_sapling": "βλαστάρι σημύδας",
  "block.minecraft.jungle_sapling": "βλαστάρι ζούγκλας",
  "block.minecraft.acacia_sapling": "βλαστάρι ακακίας",
  "block.minecraft.dark_oak_sapling": "βλαστάρι σκούρας βελανιδιάς",
  "block.minecraft.bedrock": "βραχώδες υπόστρωμα",
  "block.minecraft.sand": "άμμος",
  "block.minecraft.red_sand": "κόκκινη άμμος",
  "block.minecraft.gravel": "χαλίκι",
  "block.minecraft.gold_ore": "μετάλλευμα χρυσού",
  "block.minecraft.iron_ore": "μετάλλευμα σιδήρου",
  "block.minecraft.coal_ore": "μετάλλευμα κάρβουνου",
  "block.minecraft.nether_gold_ore": "μετάλλευμα χρυσού νέδερ",
  "block.minecraft.oak_log": "κορμός βελανιδιάς",
  "block.minecraft.spruce_log": "κορμός ελάτου",
  "block.minecraft.birch_log": "κορμός σημύδας",
  "block.minecraft.jungle_log": "κορμός ζούγκλας",
  "block.minecraft.acacia_log": "κορμός ακακίας",
  "block.minecraft.dark_oak_log": "κορμός σκούρας βελανιδιάς",
  "block.minecraft.crimson_stem": "ερυθρός βλαστός",
  "block.minecraft.warped_stem": "διαστρεβλωμένος βλαστός",
  "block.minecraft.stripped_oak_log": "αποφλοιωμένος κορμός βελανιδιάς",
  "block.minecraft.stripped_spruce_log": "αποφλοιωμένος κορμός ελάτου",
  "block.minecraft.stripped_birch_log": "αποφλοιωμένος κορμός σημύδας",
  "block.minecraft.stripped_jungle_log": "αποφλοιωμένος κορμός ζούγκλας",
  "block.minecraft.stripped_acacia_log": "αποφλοιωμένος κορμός ακακίας",
  "block.minecraft.stripped_dark_oak_log": "αποφλοιωμένος κορμός σκούρας βελανιδιάς",
  "block.minecraft.stripped_crimson_stem": "αποφλοιωμένος ερυθρός βλαστός",
  "block.minecraft.stripped_warped_stem": "αποφλοιωμένος διαστρεβλωμένος βλαστός",
  "block.minecraft.stripped_oak_wood": "αποφλοιωμένο ξύλο βελανιδιάς",
  "block.minecraft.stripped_spruce_wood": "αποφλοιωμένο ξύλο ελάτου",
  "block.minecraft.stripped_birch_wood": "αποφλοιωμένο ξύλο σημύδας",
  "block.minecraft.stripped_jungle_wood": "αποφλοιωμένο ξύλο ζούγκλας",
  "block.minecraft.stripped_acacia_wood": "αποφλοιωμένο ξύλο ακακίας",
  "block.minecraft.stripped_dark_oak_wood": "αποφλοιωμένο ξύλο σκούρας βελανιδιάς",
  "block.minecraft.stripped_crimson_hyphae": "αποφλοιωμένες ερυθρές υφές",
  "block.minecraft.stripped_warped_hyphae": "αποφλοιωμένες διαστρεβλωμένες υφές",
  "block.minecraft.oak_wood": "ξύλο βελανιδιάς",
  "block.minecraft.spruce_wood": "ξύλο ελάτου",
  "block.minecraft.birch_wood": "ξύλο σημύδας",
  "block.minecraft.jungle_wood": "ξύλο ζούγκλας",
  "block.minecraft.acacia_wood": "ξύλο ακακίας",
  "block.minecraft.dark_oak_wood": "ξύλο σκούρας βελανιδιάς",
  "block.minecraft.crimson_hyphae": "ερυθρές υφές",
  "block.minecraft.warped_hyphae": "διαστρεβλωμένες υφές",
  "block.minecraft.oak_leaves": "φύλλα βελανιδιάς",
  "block.minecraft.spruce_leaves": "φύλλα ελάτου",
  "block.minecraft.birch_leaves": "φύλλα σημύδας",
  "block.minecraft.jungle_leaves": "φύλλα ζούγκλας",
  "block.minecraft.acacia_leaves": "φύλλα ακακίας",
  "block.minecraft.dark_oak_leaves": "φύλλα σκούρας βελανιδιάς",
  "block.minecraft.sponge": "σφουγγάρι",
  "block.minecraft.wet_sponge": "βρεγμένο σφουγγάρι",
  "block.minecraft.glass": "γυαλί",
  "block.minecraft.lapis_ore": "μετάλλευμα λάπις λάζουλι",
  "block.minecraft.lapis_block": "κύβος λάπις λάζουλι",
  "block.minecraft.dispenser": "διανομέας",
  "block.minecraft.sandstone": "αμμόπετρα",
  "block.minecraft.chiseled_sandstone": "λαξευμένη αμμόπετρα",
  "block.minecraft.cut_sandstone": "κομμένη αμμόπετρα",
  "block.minecraft.note_block": "κύβος νότας",
  "block.minecraft.powered_rail": "τροφοδοτούμενη ράγα",
  "block.minecraft.detector_rail": "ράγα ανίχνευσης",
  "block.minecraft.sticky_piston": "κολλώδες πιστόνι",
  "block.minecraft.cobweb": "ιστός αράχνης",
  "block.minecraft.grass": "γρασίδι",
  "block.minecraft.fern": "φτέρη",
  "block.minecraft.dead_bush": "μαραμένος θάμνος",
  "block.minecraft.seagrass": "θαλάσσιο γρασίδι",
  "block.minecraft.sea_pickle": "θαλάσσιο τουρσί",
  "block.minecraft.piston": "πιστόνι",
  "block.minecraft.white_wool": "λευκό μαλλί",
  "block.minecraft.orange_wool": "πορτοκαλί μαλλί",
  "block.minecraft.magenta_wool": "φούξια μαλλί",
  "block.minecraft.light_blue_wool": "γαλάζιο μαλλί",
  "block.minecraft.yellow_wool": "κίτρινο μαλλί",
  "block.minecraft.lime_wool": "λαχανί μαλλί",
  "block.minecraft.pink_wool": "ροζ μαλλί",
  "block.minecraft.gray_wool": "γκρίζο μαλλί",
  "block.minecraft.light_gray_wool": "ανοιχτό γκρίζο μαλλί",
  "block.minecraft.cyan_wool": "κυανό μαλλί",
  "block.minecraft.purple_wool": "μοβ μαλλί",
  "block.minecraft.blue_wool": "μπλε μαλλί",
  "block.minecraft.brown_wool": "καφέ μαλλί",
  "block.minecraft.green_wool": "πράσινο μαλλί",
  "block.minecraft.red_wool": "κόκκινο μαλλί",
  "block.minecraft.black_wool": "μαύρο μαλλί",
  "block.minecraft.dandelion": "πικραλίδα",
  "block.minecraft.poppy": "παπαρούνα",
  "block.minecraft.blue_orchid": "μπλε ορχιδέα",
  "block.minecraft.allium": "άλλιο",
  "block.minecraft.azure_bluet": "αζουρία",
  "block.minecraft.red_tulip": "κόκκινη τουλίπα",
  "block.minecraft.orange_tulip": "πορτοκαλί τουλίπα",
  "block.minecraft.white_tulip": "λευκή τουλίπα",
  "block.minecraft.pink_tulip": "ροζ τουλίπα",
  "block.minecraft.oxeye_daisy": "μαργαρίτα",
  "block.minecraft.cornflower": "κενταύρια",
  "block.minecraft.lily_of_the_valley": "κρίνος της κοιλάδας",
  "block.minecraft.wither_rose": "τριαντάφυλλο ουίδερ",
  "block.minecraft.brown_mushroom": "καφέ μανιτάρι",
  "block.minecraft.red_mushroom": "κόκκινο μανιτάρι",
  "block.minecraft.crimson_fungus": "ερυθρός μύκητας",
  "block.minecraft.warped_fungus": "διαστρεβλωμένος μύκητας",
  "block.minecraft.crimson_roots": "ερυθρές ρίζες",
  "block.minecraft.warped_roots": "διαστρεβλωμένες ρίζες",
  "block.minecraft.nether_sprouts": "βλαστάρια νέδερ",
  "block.minecraft.weeping_vines": "κλαίουσες κληματσίδες",
  "block.minecraft.twisting_vines": "στριφογυριστές κληματσίδες",
  "block.minecraft.sugar_cane": "ζαχαροκάλαμο",
  "block.minecraft.kelp": "φύκι",
  "block.minecraft.bamboo": "μπαμπού",
  "block.minecraft.gold_block": "κύβος χρυσού",
  "block.minecraft.iron_block": "κύβος σιδήρου",
  "block.minecraft.oak_slab": "πλάκα βελανιδιάς",
  "block.minecraft.spruce_slab": "πλάκα ελάτου",
  "block.minecraft.birch_slab": "πλάκα σημύδας",
  "block.minecraft.jungle_slab": "πλάκα ζούγκλας",
  "block.minecraft.acacia_slab": "πλάκα ακακίας",
  "block.minecraft.dark_oak_slab": "πλάκα σκούρας βελανιδιάς",
  "block.minecraft.crimson_slab": "ερυθρή πλάκα",
  "block.minecraft.warped_slab": "διαστρεβλωμένη πλάκα",
  "block.minecraft.stone_slab": "πλάκα πέτρας",
  "block.minecraft.smooth_stone_slab": "πλάκα λείας πέτρας",
  "block.minecraft.sandstone_slab": "πλάκα αμμόπετρας",
  "block.minecraft.cut_sandstone_slab": "πλάκα κομμένης αμμόπετρας",
  "block.minecraft.petrified_oak_slab": "πλάκα απολιθωμένης βελανιδιάς",
  "block.minecraft.cobblestone_slab": "πλάκα κροκάλας",
  "block.minecraft.brick_slab": "πλάκα τούβλων",
  "block.minecraft.stone_brick_slab": "πλάκα τούβλων πέτρας",
  "block.minecraft.nether_brick_slab": "πλάκα τούβλων νέδερ",
  "block.minecraft.quartz_slab": "πλάκα χαλαζία",
  "block.minecraft.red_sandstone_slab": "πλάκα κόκκινης αμμόπετρας",
  "block.minecraft.cut_red_sandstone_slab": "πλάκα κομμένης κόκκινης αμμόπετρας",
  "block.minecraft.purpur_slab": "πλάκα πέρπουρ",
  "block.minecraft.prismarine_slab": "πλάκα πρισμαρίνης",
  "block.minecraft.prismarine_brick_slab": "πλάκα τούβλων πρισμαρίνης",
  "block.minecraft.dark_prismarine_slab": "πλάκα σκούρας πρισμαρίνης",
  "block.minecraft.smooth_quartz": "κύβος λείου χαλαζία",
  "block.minecraft.smooth_red_sandstone": "λεία κόκκινη αμμόπετρα",
  "block.minecraft.smooth_sandstone": "λεία αμμόπετρα",
  "block.minecraft.smooth_stone": "λεία πέτρα",
  "block.minecraft.bricks": "τούβλα",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "βιβλιοθήκη",
  "block.minecraft.mossy_cobblestone": "βρυώδης κροκάλα",
  "block.minecraft.obsidian": "οψιδιανός",
  "block.minecraft.torch": "πυρσός",
  "block.minecraft.end_rod": "ράβδος εντ",
  "block.minecraft.chorus_plant": "χορικό φυτό",
  "block.minecraft.chorus_flower": "χορικό άνθος",
  "block.minecraft.purpur_block": "κύβος πέρπουρ",
  "block.minecraft.purpur_pillar": "κίονας πέρπουρ",
  "block.minecraft.purpur_stairs": "σκάλες πέρπουρ",
  "block.minecraft.spawner": "γεννήτρια",
  "block.minecraft.oak_stairs": "σκάλες βελανιδιάς",
  "block.minecraft.chest": "σεντούκι",
  "block.minecraft.diamond_ore": "μετάλλευμα διαμαντιού",
  "block.minecraft.diamond_block": "κύβος διαμαντιού",
  "block.minecraft.crafting_table": "τραπέζι κατασκευής",
  "block.minecraft.farmland": "οργωμένο χώμα",
  "block.minecraft.furnace": "φούρνος",
  "block.minecraft.ladder": "σκάλα",
  "block.minecraft.rail": "ράγα",
  "block.minecraft.cobblestone_stairs": "σκάλες κροκάλας",
  "block.minecraft.lever": "μοχλός",
  "block.minecraft.stone_pressure_plate": "πλάκα πίεσης πέτρας",
  "block.minecraft.oak_pressure_plate": "πλάκα πίεσης βελανιδιάς",
  "block.minecraft.spruce_pressure_plate": "πλάκα πίεσης ελάτου",
  "block.minecraft.birch_pressure_plate": "πλάκα πίεσης σημύδας",
  "block.minecraft.jungle_pressure_plate": "πλάκα πίεσης ζούγκλας",
  "block.minecraft.acacia_pressure_plate": "πλάκα πίεσης ακακίας",
  "block.minecraft.dark_oak_pressure_plate": "πλάκα πίεσης σκούρας βελανιδιάς",
  "block.minecraft.crimson_pressure_plate": "ερυθρή πλάκα πίεσης",
  "block.minecraft.warped_pressure_plate": "διαστρεβλωμένη πλάκα πίεσης",
  "block.minecraft.polished_blackstone_pressure_plate": "πλάκα πίεσης γυαλισμένης μαυρόπετρας",
  "block.minecraft.redstone_ore": "μετάλλευμα ρέντστοουν",
  "block.minecraft.redstone_torch": "πυρσός ρέντστοουν",
  "block.minecraft.snow": "χιόνι",
  "block.minecraft.ice": "πάγος",
  "block.minecraft.snow_block": "κύβος χιονιού",
  "block.minecraft.cactus": "κάκτος",
  "block.minecraft.clay": "πηλός",
  "block.minecraft.jukebox": "τζούκμποξ",
  "block.minecraft.oak_fence": "φράχτης βελανιδιάς",
  "block.minecraft.spruce_fence": "φράχτης ελάτου",
  "block.minecraft.birch_fence": "φράχτης σημύδας",
  "block.minecraft.jungle_fence": "φράχτης ζούγκλας",
  "block.minecraft.acacia_fence": "φράχτης ακακίας",
  "block.minecraft.dark_oak_fence": "φράχτης σκούρας βελανιδιάς",
  "block.minecraft.crimson_fence": "ερυθρός φράχτης",
  "block.minecraft.warped_fence": "διαστρεβλωμένος φράχτης",
  "block.minecraft.pumpkin": "κολοκύθα",
  "block.minecraft.carved_pumpkin": "σκαλισμένη κολοκύθα",
  "block.minecraft.netherrack": "νέδερακ",
  "block.minecraft.soul_sand": "άμμος ψυχών",
  "block.minecraft.soul_soil": "χώμα ψυχών",
  "block.minecraft.basalt": "βασάλτης",
  "block.minecraft.polished_basalt": "γυαλισμένος βασάλτης",
  "block.minecraft.soul_torch": "πυρσός ψυχών",
  "block.minecraft.glowstone": "λαμψόπετρα",
  "block.minecraft.jack_o_lantern": "φανάρι κολοκύθας",
  "block.minecraft.oak_trapdoor": "καταπακτή βελανιδιάς",
  "block.minecraft.spruce_trapdoor": "καταπακτή ελάτου",
  "block.minecraft.birch_trapdoor": "καταπακτή σημύδας",
  "block.minecraft.jungle_trapdoor": "καταπακτή ζούγκλας",
  "block.minecraft.acacia_trapdoor": "καταπακτή ακακίας",
  "block.minecraft.dark_oak_trapdoor": "καταπακτή σκούρας βελανιδιάς",
  "block.minecraft.crimson_trapdoor": "ερυθρή καταπακτή",
  "block.minecraft.warped_trapdoor": "διαστρεβλωμένη καταπακτή",
  "block.minecraft.infested_stone": "μολυσμένη πέτρα",
  "block.minecraft.infested_cobblestone": "μολυσμένη κροκάλα",
  "block.minecraft.infested_stone_bricks": "μολυσμένα τούβλα πέτρας",
  "block.minecraft.infested_mossy_stone_bricks": "μολυσμένα βρυώδη τούβλα πέτρας",
  "block.minecraft.infested_cracked_stone_bricks": "μολυσμένα ραγισμένα τούβλα πέτρας",
  "block.minecraft.infested_chiseled_stone_bricks": "μολυσμένα λαξευμένα τούβλα πέτρας",
  "block.minecraft.stone_bricks": "τούβλα πέτρας",
  "block.minecraft.mossy_stone_bricks": "βρυώδη τούβλα πέτρας",
  "block.minecraft.cracked_stone_bricks": "ραγισμένα τούβλα πέτρας",
  "block.minecraft.chiseled_stone_bricks": "λαξευμένα τούβλα πέτρας",
  "block.minecraft.brown_mushroom_block": "κύβος καφέ μανιταριού",
  "block.minecraft.red_mushroom_block": "κύβος κόκκινου μανιταριού",
  "block.minecraft.mushroom_stem": "βλαστός μανιταριού",
  "block.minecraft.iron_bars": "κάγκελα σιδήρου",
  "block.minecraft.chain": "αλυσίδα",
  "block.minecraft.glass_pane": "υαλοπίνακας",
  "block.minecraft.melon": "καρπούζι",
  "block.minecraft.vine": "κληματσίδες",
  "block.minecraft.oak_fence_gate": "πύλη φράχτη βελανιδιάς",
  "block.minecraft.spruce_fence_gate": "πύλη φράχτη ελάτου",
  "block.minecraft.birch_fence_gate": "πύλη φράχτη σημύδας",
  "block.minecraft.jungle_fence_gate": "πύλη φράχτη ζούγκλας",
  "block.minecraft.acacia_fence_gate": "πύλη φράχτη ακακίας",
  "block.minecraft.dark_oak_fence_gate": "πύλη φράχτη σκούρας βελανιδιάς",
  "block.minecraft.crimson_fence_gate": "ερυθρή πύλη φράχτη",
  "block.minecraft.warped_fence_gate": "διαστρεβλωμένη πύλη φράχτη",
  "block.minecraft.brick_stairs": "σκάλες τούβλων",
  "block.minecraft.stone_brick_stairs": "σκάλες τούβλων πέτρας",
  "block.minecraft.mycelium": "μυκήλιο",
  "block.minecraft.lily_pad": "νούφαρο",
  "block.minecraft.nether_bricks": "τούβλα νέδερ",
  "block.minecraft.cracked_nether_bricks": "ραγισμένα τούβλα νέδερ",
  "block.minecraft.chiseled_nether_bricks": "λαξευμένα τούβλα νέδερ",
  "block.minecraft.nether_brick_fence": "φράχτης τούβλων νέδερ",
  "block.minecraft.nether_brick_stairs": "σκάλες τούβλων νέδερ",
  "block.minecraft.enchanting_table": "τραπέζι μαγέματος",
  "block.minecraft.end_portal_frame": "πλαίσιο πύλης εντ",
  "block.minecraft.end_stone": "πέτρα εντ",
  "block.minecraft.end_stone_bricks": "τούβλα πέτρας εντ",
  "block.minecraft.dragon_egg": "αβγό δράκου",
  "block.minecraft.redstone_lamp": "λάμπα ρέντστοουν",
  "block.minecraft.sandstone_stairs": "σκάλες αμμόπετρας",
  "block.minecraft.emerald_ore": "μετάλλευμα σμαραγδιού",
  "block.minecraft.ender_chest": "σεντούκι έντερ",
  "block.minecraft.tripwire_hook": "γάντζος πλέγματος κλωστής",
  "block.minecraft.emerald_block": "κύβος σμαραγδιού",
  "block.minecraft.spruce_stairs": "σκάλες ελάτου",
  "block.minecraft.birch_stairs": "σκάλες σημύδας",
  "block.minecraft.jungle_stairs": "σκάλες ζούγκλας",
  "block.minecraft.crimson_stairs": "ερυθρές σκάλες",
  "block.minecraft.warped_stairs": "διαστρεβλωμένες σκάλες",
  "block.minecraft.command_block": "κύβος εντολής",
  "block.minecraft.beacon": "φάρος",
  "block.minecraft.cobblestone_wall": "τοίχος κροκάλας",
  "block.minecraft.mossy_cobblestone_wall": "τοίχος βρυώδους κροκάλας",
  "block.minecraft.brick_wall": "τοίχος τούβλων",
  "block.minecraft.prismarine_wall": "τοίχος πρισμαρίνης",
  "block.minecraft.red_sandstone_wall": "τοίχος κόκκινης αμμόπετρας",
  "block.minecraft.mossy_stone_brick_wall": "τοίχος βρυωδών τούβλων πέτρας",
  "block.minecraft.granite_wall": "τοίχος γρανίτη",
  "block.minecraft.stone_brick_wall": "τοίχος τούβλων πέτρας",
  "block.minecraft.nether_brick_wall": "τοίχος τούβλων νέδερ",
  "block.minecraft.andesite_wall": "τοίχος ανδεσίτη",
  "block.minecraft.red_nether_brick_wall": "τοίχος κόκκινων τούβλων νέδερ",
  "block.minecraft.sandstone_wall": "τοίχος αμμόπετρας",
  "block.minecraft.end_stone_brick_wall": "τοίχος τούβλων πέτρας εντ",
  "block.minecraft.diorite_wall": "τοίχος διορίτη",
  "block.minecraft.blackstone_wall": "τοίχος μαυρόπετρας",
  "block.minecraft.polished_blackstone_wall": "τοίχος γυαλισμένης μαυρόπετρας",
  "block.minecraft.polished_blackstone_brick_wall": "τοίχος γυαλισμένων τούβλων μαυρόπετρας",
  "block.minecraft.stone_button": "κουμπί πέτρας",
  "block.minecraft.oak_button": "κουμπί βελανιδιάς",
  "block.minecraft.spruce_button": "κουμπί ελάτου",
  "block.minecraft.birch_button": "κουμπί σημύδας",
  "block.minecraft.jungle_button": "κουμπί ζούγκλας",
  "block.minecraft.acacia_button": "κουμπί ακακίας",
  "block.minecraft.dark_oak_button": "κουμπί σκούρας βελανιδιάς",
  "block.minecraft.crimson_button": "ερυθρό κουμπί",
  "block.minecraft.warped_button": "διαστρεβλωμένο κουμπί",
  "block.minecraft.polished_blackstone_button": "κουμπί γυαλισμένης μαυρόπετρας",
  "block.minecraft.anvil": "αμόνι",
  "block.minecraft.chipped_anvil": "φθαρμένο αμόνι",
  "block.minecraft.damaged_anvil": "κατεστραμμένο αμόνι",
  "block.minecraft.trapped_chest": "σεντούκι παγίδα",
  "block.minecraft.light_weighted_pressure_plate": "πλάκα πίεσης μικρού βάρους",
  "block.minecraft.heavy_weighted_pressure_plate": "πλάκα πίεσης μεγάλου βάρους",
  "block.minecraft.daylight_detector": "ανιχνευτής φωτός ημέρας",
  "block.minecraft.redstone_block": "κύβος ρέντστοουν",
  "block.minecraft.nether_quartz_ore": "μετάλλευμα χαλαζία νέδερ",
  "block.minecraft.hopper": "χοάνη",
  "block.minecraft.chiseled_quartz_block": "κύβος λαξευμένου χαλαζία",
  "block.minecraft.quartz_block": "κύβος χαλαζία",
  "block.minecraft.quartz_bricks": "τούβλα χαλαζία",
  "block.minecraft.quartz_pillar": "κίονας χαλαζία",
  "block.minecraft.quartz_stairs": "σκάλες χαλαζία",
  "block.minecraft.activator_rail": "ράγα ενεργοποίησης",
  "block.minecraft.dropper": "ρίχτης",
  "block.minecraft.white_terracotta": "λευκή τερακότα",
  "block.minecraft.orange_terracotta": "πορτοκαλί τερακότα",
  "block.minecraft.magenta_terracotta": "φούξια τερακότα",
  "block.minecraft.light_blue_terracotta": "γαλάζια τερακότα",
  "block.minecraft.yellow_terracotta": "κίτρινη τερακότα",
  "block.minecraft.lime_terracotta": "λαχανί τερακότα",
  "block.minecraft.pink_terracotta": "ροζ τερακότα",
  "block.minecraft.gray_terracotta": "γκρίζα τερακότα",
  "block.minecraft.light_gray_terracotta": "ανοιχτή γκρίζα τερακότα",
  "block.minecraft.cyan_terracotta": "κυανή τερακότα",
  "block.minecraft.purple_terracotta": "μοβ τερακότα",
  "block.minecraft.blue_terracotta": "μπλε τερακότα",
  "block.minecraft.brown_terracotta": "καφέ τερακότα",
  "block.minecraft.green_terracotta": "πράσινη τερακότα",
  "block.minecraft.red_terracotta": "κόκκινη τερακότα",
  "block.minecraft.black_terracotta": "μαύρη τερακότα",
  "block.minecraft.barrier": "φράγμα",
  "block.minecraft.iron_trapdoor": "καταπακτή σιδήρου",
  "block.minecraft.hay_block": "δεμάτι σανό",
  "block.minecraft.white_carpet": "λευκό χαλί",
  "block.minecraft.orange_carpet": "πορτοκαλί χαλί",
  "block.minecraft.magenta_carpet": "φούξια χαλί",
  "block.minecraft.light_blue_carpet": "γαλάζιο χαλί",
  "block.minecraft.yellow_carpet": "κίτρινο χαλί",
  "block.minecraft.lime_carpet": "λαχανί χαλί",
  "block.minecraft.pink_carpet": "ροζ χαλί",
  "block.minecraft.gray_carpet": "γκρίζο χαλί",
  "block.minecraft.light_gray_carpet": "ανοιχτό γκρίζο χαλί",
  "block.minecraft.cyan_carpet": "κυανό χαλί",
  "block.minecraft.purple_carpet": "μοβ χαλί",
  "block.minecraft.blue_carpet": "μπλε χαλί",
  "block.minecraft.brown_carpet": "καφέ χαλί",
  "block.minecraft.green_carpet": "πράσινο χαλί",
  "block.minecraft.red_carpet": "κόκκινο χαλί",
  "block.minecraft.black_carpet": "μαύρο χαλί",
  "block.minecraft.terracotta": "τερακότα",
  "block.minecraft.coal_block": "κύβος κάρβουνου",
  "block.minecraft.packed_ice": "συμπιεσμένος πάγος",
  "block.minecraft.acacia_stairs": "σκάλες ακακίας",
  "block.minecraft.dark_oak_stairs": "σκάλες σκούρας βελανιδιάς",
  "block.minecraft.slime_block": "κύβος γλίτσας",
  "block.minecraft.grass_path": "μονοπάτι γρασιδιού",
  "block.minecraft.sunflower": "ηλίανθος",
  "block.minecraft.lilac": "πασχαλιά",
  "block.minecraft.rose_bush": "θάμνος τριαντάφυλλων",
  "block.minecraft.peony": "παιώνια",
  "block.minecraft.tall_grass": "ψηλό γρασίδι",
  "block.minecraft.large_fern": "μεγάλη φτέρη",
  "block.minecraft.white_stained_glass": "λευκό χρωματισμένο γυαλί",
  "block.minecraft.orange_stained_glass": "πορτοκαλί χρωματισμένο γυαλί",
  "block.minecraft.magenta_stained_glass": "φούξια χρωματισμένο γυαλί",
  "block.minecraft.light_blue_stained_glass": "γαλάζιο χρωματισμένο γυαλί",
  "block.minecraft.yellow_stained_glass": "κίτρινο χρωματισμένο γυαλί",
  "block.minecraft.lime_stained_glass": "λαχανί χρωματισμένο γυαλί",
  "block.minecraft.pink_stained_glass": "ροζ χρωματισμένο γυαλί",
  "block.minecraft.gray_stained_glass": "γκρίζο χρωματισμένο γυαλί",
  "block.minecraft.light_gray_stained_glass": "ανοιχτό γκρίζο χρωματισμένο γυαλί",
  "block.minecraft.cyan_stained_glass": "κυανό χρωματισμένο γυαλί",
  "block.minecraft.purple_stained_glass": "μοβ χρωματισμένο γυαλί",
  "block.minecraft.blue_stained_glass": "μπλε χρωματισμένο γυαλί",
  "block.minecraft.brown_stained_glass": "καφέ χρωματισμένο γυαλί",
  "block.minecraft.green_stained_glass": "πράσινο χρωματισμένο γυαλί",
  "block.minecraft.red_stained_glass": "κόκκινο χρωματισμένο γυαλί",
  "block.minecraft.black_stained_glass": "μαύρο χρωματισμένο γυαλί",
  "block.minecraft.white_stained_glass_pane": "λευκός χρωματισμένος υαλοπίνακας",
  "block.minecraft.orange_stained_glass_pane": "πορτοκαλί χρωματισμένος υαλοπίνακας",
  "block.minecraft.magenta_stained_glass_pane": "φούξια χρωματισμένος υαλοπίνακας",
  "block.minecraft.light_blue_stained_glass_pane": "γαλάζιος χρωματισμένος υαλοπίνακας",
  "block.minecraft.yellow_stained_glass_pane": "κίτρινος χρωματισμένος υαλοπίνακας",
  "block.minecraft.lime_stained_glass_pane": "λαχανί χρωματισμένος υαλοπίνακας",
  "block.minecraft.pink_stained_glass_pane": "ροζ χρωματισμένος υαλοπίνακας",
  "block.minecraft.gray_stained_glass_pane": "γκρίζος χρωματισμένος υαλοπίνακας",
  "block.minecraft.light_gray_stained_glass_pane": "ανοιχτός γκρίζος χρωματισμένος υαλοπίνακας",
  "block.minecraft.cyan_stained_glass_pane": "κυανός χρωματισμένος υαλοπίνακας",
  "block.minecraft.purple_stained_glass_pane": "μοβ χρωματισμένος υαλοπίνακας",
  "block.minecraft.blue_stained_glass_pane": "μπλε χρωματισμένος υαλοπίνακας",
  "block.minecraft.brown_stained_glass_pane": "καφέ χρωματισμένος υαλοπίνακας",
  "block.minecraft.green_stained_glass_pane": "πράσινος χρωματισμένος υαλοπίνακας",
  "block.minecraft.red_stained_glass_pane": "κόκκινος χρωματισμένος υαλοπίνακας",
  "block.minecraft.black_stained_glass_pane": "μαύρος χρωματισμένος υαλοπίνακας",
  "block.minecraft.prismarine": "πρισμαρίνη",
  "block.minecraft.prismarine_bricks": "τούβλα πρισμαρίνης",
  "block.minecraft.dark_prismarine": "σκούρα πρισμαρίνη",
  "block.minecraft.prismarine_stairs": "σκάλες πρισμαρίνης",
  "block.minecraft.prismarine_brick_stairs": "σκάλες τούβλων πρισμαρίνης",
  "block.minecraft.dark_prismarine_stairs": "σκάλες σκούρας πρισμαρίνης",
  "block.minecraft.sea_lantern": "θαλάσσιο φανάρι",
  "block.minecraft.red_sandstone": "κόκκινη αμμόπετρα",
  "block.minecraft.chiseled_red_sandstone": "λαξευμένη κόκκινη αμμόπετρα",
  "block.minecraft.cut_red_sandstone": "κομμένη κόκκινη αμμόπετρα",
  "block.minecraft.red_sandstone_stairs": "σκάλες κόκκινης αμμόπετρας",
  "block.minecraft.repeating_command_block": "κύβος εντολής επανάληψης",
  "block.minecraft.chain_command_block": "κύβος εντολής αλυσίδας",
  "block.minecraft.magma_block": "κύβος μάγματος",
  "block.minecraft.nether_wart_block": "κύβος στίγματος νέδερ",
  "block.minecraft.warped_wart_block": "κύβος διαστρεβλωμένου στίγματος",
  "block.minecraft.red_nether_bricks": "κόκκινα τούβλα νέδερ",
  "block.minecraft.bone_block": "κύβος οστών",
  "block.minecraft.structure_void": "κενό δομής",
  "block.minecraft.observer": "παρατηρητής",
  "block.minecraft.shulker_box": "κουτί σάλκερ",
  "block.minecraft.white_shulker_box": "λευκό κουτί σάλκερ",
  "block.minecraft.orange_shulker_box": "πορτοκαλί κουτί σάλκερ",
  "block.minecraft.magenta_shulker_box": "φούξια κουτί σάλκερ",
  "block.minecraft.light_blue_shulker_box": "γαλάζιο κουτί σάλκερ",
  "block.minecraft.yellow_shulker_box": "κίτρινο κουτί σάλκερ",
  "block.minecraft.lime_shulker_box": "λαχανί κουτί σάλκερ",
  "block.minecraft.pink_shulker_box": "ροζ κουτί σάλκερ",
  "block.minecraft.gray_shulker_box": "γκρίζο κουτί σάλκερ",
  "block.minecraft.light_gray_shulker_box": "ανοιχτό γκρίζο κουτί σάλκερ",
  "block.minecraft.cyan_shulker_box": "κυανό κουτί σάλκερ",
  "block.minecraft.purple_shulker_box": "μοβ κουτί σάλκερ",
  "block.minecraft.blue_shulker_box": "μπλε κουτί σάλκερ",
  "block.minecraft.brown_shulker_box": "καφέ κουτί σάλκερ",
  "block.minecraft.green_shulker_box": "πράσινο κουτί σάλκερ",
  "block.minecraft.red_shulker_box": "κόκκινο κουτί σάλκερ",
  "block.minecraft.black_shulker_box": "μαύρο κουτί σάλκερ",
  "block.minecraft.white_glazed_terracotta": "λευκή γυαλισμένη τερακότα",
  "block.minecraft.orange_glazed_terracotta": "πορτοκάλι γυαλισμένη τερακότα",
  "block.minecraft.magenta_glazed_terracotta": "φούξια γυαλισμένη τερακότα",
  "block.minecraft.light_blue_glazed_terracotta": "γαλάζια γυαλισμένη τερακότα",
  "block.minecraft.yellow_glazed_terracotta": "κίτρινη γυαλισμένη τερακότα",
  "block.minecraft.lime_glazed_terracotta": "λαχανί γυαλισμένη τερακότα",
  "block.minecraft.pink_glazed_terracotta": "ροζ γυαλισμένη τερακότα",
  "block.minecraft.gray_glazed_terracotta": "γκρίζα γυαλισμένη τερακότα",
  "block.minecraft.light_gray_glazed_terracotta": "ανοιχτή γκρίζα γυαλισμένη τερακότα",
  "block.minecraft.cyan_glazed_terracotta": "κυανή γυαλισμένη τερακότα",
  "block.minecraft.purple_glazed_terracotta": "μοβ γυαλισμένη τερακότα",
  "block.minecraft.blue_glazed_terracotta": "μπλε γυαλισμένη τερακότα",
  "block.minecraft.brown_glazed_terracotta": "καφέ γυαλισμένη τερακότα",
  "block.minecraft.green_glazed_terracotta": "πράσινη γυαλισμένη τερακότα",
  "block.minecraft.red_glazed_terracotta": "κόκκινη γυαλισμένη τερακότα",
  "block.minecraft.black_glazed_terracotta": "μαύρη γυαλισμένη τερακότα",
  "block.minecraft.white_concrete": "λευκό σκυρόδεμα",
  "block.minecraft.orange_concrete": "πορτοκαλί σκυρόδεμα",
  "block.minecraft.magenta_concrete": "φούξια σκυρόδεμα",
  "block.minecraft.light_blue_concrete": "γαλάζιο σκυρόδεμα",
  "block.minecraft.yellow_concrete": "κίτρινο σκυρόδεμα",
  "block.minecraft.lime_concrete": "λαχανί σκυρόδεμα",
  "block.minecraft.pink_concrete": "ροζ σκυρόδεμα",
  "block.minecraft.gray_concrete": "γκρίζο σκυρόδεμα",
  "block.minecraft.light_gray_concrete": "ανοιχτό γκρίζο σκυρόδεμα",
  "block.minecraft.cyan_concrete": "κυανό σκυρόδεμα",
  "block.minecraft.purple_concrete": "μοβ σκυρόδεμα",
  "block.minecraft.blue_concrete": "μπλε σκυρόδεμα",
  "block.minecraft.brown_concrete": "καφέ σκυρόδεμα",
  "block.minecraft.green_concrete": "πράσινο σκυρόδεμα",
  "block.minecraft.red_concrete": "κόκκινο σκυρόδεμα",
  "block.minecraft.black_concrete": "μαύρο σκυρόδεμα",
  "block.minecraft.white_concrete_powder": "λευκή σκόνη σκυροδέματος",
  "block.minecraft.orange_concrete_powder": "πορτοκαλί σκόνη σκυροδέματος",
  "block.minecraft.magenta_concrete_powder": "φούξια σκόνη σκυροδέματος",
  "block.minecraft.light_blue_concrete_powder": "γαλάζια σκόνη σκυροδέματος",
  "block.minecraft.yellow_concrete_powder": "κίτρινη σκόνη σκυροδέματος",
  "block.minecraft.lime_concrete_powder": "λαχανί σκόνη σκυροδέματος",
  "block.minecraft.pink_concrete_powder": "ροζ σκόνη σκυροδέματος",
  "block.minecraft.gray_concrete_powder": "γκρίζα σκόνη σκυροδέματος",
  "block.minecraft.light_gray_concrete_powder": "ανοιχτή γκρίζα σκόνη σκυροδέματος",
  "block.minecraft.cyan_concrete_powder": "κυανή σκόνη σκυροδέματος",
  "block.minecraft.purple_concrete_powder": "μοβ σκόνη σκυροδέματος",
  "block.minecraft.blue_concrete_powder": "μπλε σκόνη σκυροδέματος",
  "block.minecraft.brown_concrete_powder": "καφέ σκόνη σκυροδέματος",
  "block.minecraft.green_concrete_powder": "πράσινη σκόνη σκυροδέματος",
  "block.minecraft.red_concrete_powder": "κόκκινη σκόνη σκυροδέματος",
  "block.minecraft.black_concrete_powder": "μαύρη σκόνη σκυροδέματος",
  "block.minecraft.turtle_egg": "αβγό χελώνας",
  "block.minecraft.dead_tube_coral_block": "κύβος νεκρού μπλε κοραλλιού",
  "block.minecraft.dead_brain_coral_block": "κύβος νεκρού ροζ κοραλλιού",
  "block.minecraft.dead_bubble_coral_block": "κύβος νεκρού μοβ κοραλλιού",
  "block.minecraft.dead_fire_coral_block": "κύβος νεκρού κόκκινου κοραλλιού",
  "block.minecraft.dead_horn_coral_block": "κύβος νεκρού κίτρινου κοραλλιού",
  "block.minecraft.tube_coral_block": "κύβος μπλε κοραλλιού",
  "block.minecraft.brain_coral_block": "κύβος ροζ κοραλλιού",
  "block.minecraft.bubble_coral_block": "κύβος μοβ κοραλλιού",
  "block.minecraft.fire_coral_block": "κύβος κόκκινου κοραλλιού",
  "block.minecraft.horn_coral_block": "κύβος κίτρινου κοραλλιού",
  "block.minecraft.tube_coral": "μπλε κοράλλι",
  "block.minecraft.brain_coral": "ροζ κοράλλι",
  "block.minecraft.bubble_coral": "μοβ κοράλλι",
  "block.minecraft.fire_coral": "κόκκινο κοράλλι",
  "block.minecraft.horn_coral": "κίτρινο κοράλλι",
  "block.minecraft.dead_brain_coral": "νεκρό ροζ κοράλλι",
  "block.minecraft.dead_bubble_coral": "νεκρό μοβ κοράλλι",
  "block.minecraft.dead_fire_coral": "νεκρό κόκκινο κοράλλι",
  "block.minecraft.dead_horn_coral": "νεκρό κίτρινο κοράλλι",
  "block.minecraft.dead_tube_coral": "νεκρό μπλε κοράλλι",
  "block.minecraft.tube_coral_fan": "μπλε αλκυονοειδές κοράλλι",
  "block.minecraft.brain_coral_fan": "ροζ αλκυονοειδές κοράλλι",
  "block.minecraft.bubble_coral_fan": "μοβ αλκυονοειδές κοράλλι",
  "block.minecraft.fire_coral_fan": "κόκκινο αλκυονοειδές κοράλλι",
  "block.minecraft.horn_coral_fan": "κίτρινο αλκυονοειδές κοράλλι",
  "block.minecraft.dead_tube_coral_fan": "νεκρό μπλε αλκυονοειδές κοράλλι",
  "block.minecraft.dead_brain_coral_fan": "νεκρό ροζ αλκυονοειδές κοράλλι",
  "block.minecraft.dead_bubble_coral_fan": "νεκρό μοβ αλκυονοειδές κοράλλι",
  "block.minecraft.dead_fire_coral_fan": "νεκρό κόκκινο αλκυονοειδές κοράλλι",
  "block.minecraft.dead_horn_coral_fan": "νεκρό κίτρινο αλκυονοειδές κοράλλι",
  "block.minecraft.blue_ice": "μπλε πάγος",
  "block.minecraft.conduit": "διαγωγέας",
  "block.minecraft.polished_granite_stairs": "σκάλες γυαλισμένου γρανίτη",
  "block.minecraft.smooth_red_sandstone_stairs": "σκάλες λείας κόκκινης αμμόπετρας",
  "block.minecraft.mossy_stone_brick_stairs": "σκάλες βρυωδών τούβλων πέτρας",
  "block.minecraft.polished_diorite_stairs": "σκάλες γυαλισμένου διορίτη",
  "block.minecraft.mossy_cobblestone_stairs": "σκάλες βρυώδους κροκάλας",
  "block.minecraft.end_stone_brick_stairs": "σκάλες τούβλων πέτρας εντ",
  "block.minecraft.stone_stairs": "σκάλες πέτρας",
  "block.minecraft.smooth_sandstone_stairs": "σκάλες λείας αμμόπετρας",
  "block.minecraft.smooth_quartz_stairs": "σκάλες λείου χαλαζία",
  "block.minecraft.granite_stairs": "σκάλες γρανίτη",
  "block.minecraft.andesite_stairs": "σκάλες ανδεσίτη",
  "block.minecraft.red_nether_brick_stairs": "σκάλες κόκκινων τούβλων νέδερ",
  "block.minecraft.polished_andesite_stairs": "σκάλες γυαλισμένου ανδεσίτη",
  "block.minecraft.diorite_stairs": "σκάλες διορίτη",
  "block.minecraft.polished_granite_slab": "πλάκα γυαλισμένου γρανίτη",
  "block.minecraft.smooth_red_sandstone_slab": "πλάκα λείας κόκκινης αμμόπετρας",
  "block.minecraft.mossy_stone_brick_slab": "πλάκα βρυωδών τούβλων πέτρας",
  "block.minecraft.polished_diorite_slab": "πλάκα γυαλισμένου διορίτη",
  "block.minecraft.mossy_cobblestone_slab": "πλάκα βρυώδους κροκάλας",
  "block.minecraft.end_stone_brick_slab": "πλάκα τούβλων πέτρας εντ",
  "block.minecraft.smooth_sandstone_slab": "πλάκα λείας αμμόπετρας",
  "block.minecraft.smooth_quartz_slab": "πλάκα λείου χαλαζία",
  "block.minecraft.granite_slab": "πλάκα γρανίτη",
  "block.minecraft.andesite_slab": "πλάκα ανδεσίτη",
  "block.minecraft.red_nether_brick_slab": "πλάκα κόκκινων τούβλων νέδερ",
  "block.minecraft.polished_andesite_slab": "πλάκα γυαλισμένου ανδεσίτη",
  "block.minecraft.diorite_slab": "πλάκα διορίτη",
  "block.minecraft.scaffolding": "σκαλωσιά",
  "block.minecraft.iron_door": "πόρτα σιδήρου",
  "block.minecraft.oak_door": "πόρτα βελανιδιάς",
  "block.minecraft.spruce_door": "πόρτα ελάτου",
  "block.minecraft.birch_door": "πόρτα σημύδας",
  "block.minecraft.jungle_door": "πόρτα ζούγκλας",
  "block.minecraft.acacia_door": "πόρτα ακακίας",
  "block.minecraft.dark_oak_door": "πόρτα σκούρας βελανιδιάς",
  "block.minecraft.crimson_door": "ερυθρή πόρτα",
  "block.minecraft.warped_door": "διαστρεβλωμένη πόρτα",
  "block.minecraft.repeater": "αναμεταδότης ρέντστοουν",
  "block.minecraft.comparator": "συγκριτής ρέντστοουν",
  "block.minecraft.structure_block": "κύβος δομής",
  "block.minecraft.jigsaw": "κύβος παζλ",
  "item.minecraft.turtle_helmet": "καβούκι χελώνας□□όταν είναι στο κεφάλι:□+2 πανοπλία",
  "item.minecraft.scute": "φολίδα",
  "item.minecraft.iron_shovel": "σιδερένιο φτυάρι□□όταν είναι στο κύριο χέρι:□+3.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.iron_pickaxe": "σιδερένια αξίνα□□όταν είναι στο κύριο χέρι:□+3 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.iron_axe": "σιδερένιο τσεκούρι□□όταν είναι στο κύριο χέρι:□+8 ζημιά επίθεσης□-3.1 ταχύτητα επίθεσης",
  "item.minecraft.flint_and_steel": "πυρόλιθος και χάλυβας",
  "item.minecraft.apple": "μήλο",
  "item.minecraft.bow": "τόξο",
  "item.minecraft.arrow": "βέλος",
  "item.minecraft.coal": "κάρβουνο",
  "item.minecraft.charcoal": "ξυλοκάρβουνο",
  "item.minecraft.diamond": "διαμάντι",
  "item.minecraft.iron_ingot": "ράβδος σιδήρου",
  "item.minecraft.gold_ingot": "ράβδος χρυσού",
  "item.minecraft.netherite_ingot": "ράβδος νεδερίτη",
  "item.minecraft.netherite_scrap": "κομμάτι νεδερίτη",
  "item.minecraft.iron_sword": "σιδερένιο σπαθί□□όταν είναι στο κύριο χέρι:□+5 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.wooden_sword": "ξύλινο σπαθί□□όταν είναι στο κύριο χέρι:□+3 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.wooden_shovel": "ξύλινο φτυάρι□□όταν είναι στο κύριο χέρι:□+1.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.wooden_pickaxe": "ξύλινη αξίνα□□όταν είναι στο κύριο χέρι:□+1 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.wooden_axe": "ξύλινο τσεκούρι□□όταν είναι στο κύριο χέρι:□+6 ζημιά επίθεσης□-3.2 ταχύτητα επίθεσης",
  "item.minecraft.stone_sword": "πέτρινο σπαθί□□όταν είναι στο κύριο χέρι:□+4 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.stone_shovel": "πέτρινο φτυάρι□□όταν είναι στο κύριο χέρι:□+2.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.stone_pickaxe": "πέτρινη αξίνα□□όταν είναι στο κύριο χέρι:□+2 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.stone_axe": "πέτρινο τσεκούρι□□όταν είναι στο κύριο χέρι:□+8 ζημιά επίθεσης□-3.2 ταχύτητα επίθεσης",
  "item.minecraft.diamond_sword": "διαμαντένιο σπαθί□□όταν είναι στο κύριο χέρι:□+6 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.diamond_shovel": "διαμαντένιο φτυάρι□□όταν είναι στο κύριο χέρι:□+4.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.diamond_pickaxe": "διαμαντένια αξίνα□□όταν είναι στο κύριο χέρι:□+4 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.diamond_axe": "διαμαντένιο τσεκούρι□□όταν είναι στο κύριο χέρι:□+8 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.stick": "ξυλάκι",
  "item.minecraft.bowl": "μπολ",
  "item.minecraft.mushroom_stew": "μανιτάρια στιφάδο",
  "item.minecraft.golden_sword": "χρυσό σπαθί□□όταν είναι στο κύριο χέρι:□+3 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.golden_shovel": "χρυσό φτυάρι□□όταν είναι στο κύριο χέρι:□+1.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.golden_pickaxe": "χρυσή αξίνα□□όταν είναι στο κύριο χέρι:□+1 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.golden_axe": "χρυσό τσεκούρι□□όταν είναι στο κύριο χέρι:□+6 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.netherite_sword": "σπαθί νεδερίτη□□όταν είναι στο κύριο χέρι:□+7 ζημιά επίθεσης□-2.4 ταχύτητα επίθεσης",
  "item.minecraft.netherite_shovel": "φτυάρι νεδερίτη□□όταν είναι στο κύριο χέρι:□+5.5 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.netherite_pickaxe": "αξίνα νεδερίτη□□όταν είναι στο κύριο χέρι:□+5 ζημιά επίθεσης□-2.8 ταχύτητα επίθεσης",
  "item.minecraft.netherite_axe": "τσεκούρι νεδερίτη□□όταν είναι στο κύριο χέρι:□+9 ζημιά επίθεσης□-3 ταχύτητα επίθεσης",
  "item.minecraft.string": "νήμα",
  "item.minecraft.feather": "φτερό",
  "item.minecraft.gunpowder": "πυρίτιδα",
  "item.minecraft.wooden_hoe": "ξύλινη τσάπα□□όταν είναι στο κύριο χέρι:□-3 ταχύτητα επίθεσης",
  "item.minecraft.stone_hoe": "πέτρινη τσάπα□□όταν είναι στο κύριο χέρι:□-2 ταχύτητα επίθεσης",
  "item.minecraft.iron_hoe": "σιδερένια τσάπα□□όταν είναι στο κύριο χέρι:□-1 ταχύτητα επίθεσης",
  "item.minecraft.diamond_hoe": "διαμαντένια τσάπα□□όταν είναι στο κύριο χέρι:",
  "item.minecraft.golden_hoe": "χρυσή τσάπα□□όταν είναι στο κύριο χέρι:□-3 ταχύτητα επίθεσης",
  "item.minecraft.netherite_hoe": "τσάπα νεδερίτη□□όταν είναι στο κύριο χέρι:",
  "item.minecraft.wheat_seeds": "σπόροι σιταριού",
  "item.minecraft.wheat": "σιτάρι",
  "item.minecraft.bread": "ψωμί",
  "item.minecraft.leather_helmet": "δερμάτινο σκουφί□□όταν είναι στο κεφάλι:□+1 πανοπλία",
  "item.minecraft.leather_chestplate": "δερμάτινο χιτώνιο□□όταν είναι στο σώμα:□+3 πανοπλία",
  "item.minecraft.leather_leggings": "δερμάτινο παντελόνι□□όταν είναι στα πόδια:□+2 πανοπλία",
  "item.minecraft.leather_boots": "δερμάτινες μπότες□□όταν είναι στις πατούσες:□+1 πανοπλία",
  "item.minecraft.chainmail_helmet": "αλυσιδωτό κράνος□□όταν είναι στο κεφάλι:□+2 πανοπλία",
  "item.minecraft.chainmail_chestplate": "αλυσιδωτός θώρακας□□όταν είναι στο σώμα:□+5 πανοπλία",
  "item.minecraft.chainmail_leggings": "αλυσιδωτές περικνημίδες□□όταν είναι στα πόδια:□+4 πανοπλία",
  "item.minecraft.chainmail_boots": "αλυσιδωτές μπότες□□όταν είναι στις πατούσες:□+1 πανοπλία",
  "item.minecraft.iron_helmet": "σιδερένιο κράνος□□όταν είναι στο κεφάλι:□+2 πανοπλία",
  "item.minecraft.iron_chestplate": "σιδερένιος θώρακας□□όταν είναι στο σώμα:□+6 πανοπλία",
  "item.minecraft.iron_leggings": "σιδερένιες περικνημίδες□□όταν είναι στα πόδια:□+5 πανοπλία",
  "item.minecraft.iron_boots": "σιδερένιες μπότες□□όταν είναι στις πατούσες:□+2 πανοπλία",
  "item.minecraft.diamond_helmet": "διαμαντένιο κράνος□□όταν είναι στο κεφάλι:□+3 πανοπλία□+2 ανθεκτικότητα πανοπλίας",
  "item.minecraft.diamond_chestplate": "διαμαντένιος θώρακας□□όταν είναι στο σώμα:□+8 πανοπλία□+2 ανθεκτικότητα πανοπλίας",
  "item.minecraft.diamond_leggings": "διαμαντένιες περικνημίδες□□όταν είναι στα πόδια:□+6 πανοπλία□+2 ανθεκτικότητα πανοπλίας",
  "item.minecraft.diamond_boots": "διαμαντένιες μπότες□□όταν είναι στις πατούσες:□+3 πανοπλία□+2 ανθεκτικότητα πανοπλίας",
  "item.minecraft.golden_helmet": "χρυσό κράνος□□όταν είναι στο κεφάλι:□+2 πανοπλία",
  "item.minecraft.golden_chestplate": "χρυσός θώρακας□□όταν είναι στο σώμα:□+5 πανοπλία",
  "item.minecraft.golden_leggings": "χρυσές περικνημίδες□□όταν είναι στα πόδια:□+3 πανοπλία",
  "item.minecraft.golden_boots": "χρυσές μπότες□□όταν είναι στις πατούσες:□+1 πανοπλία",
  "item.minecraft.netherite_helmet": "κράνος νεδερίτη□□όταν είναι στο κεφάλι:□+3 πανοπλία□+3 ανθεκτικότητα πανοπλίας□+1 αντίσταση απώθησης",
  "item.minecraft.netherite_chestplate": "θώρακας νεδερίτη□□όταν είναι στο σώμα:□+8 πανοπλία□+3 ανθεκτικότητα πανοπλίας□+1 αντίσταση απώθησης",
  "item.minecraft.netherite_leggings": "περικνημίδες νεδερίτη□□όταν είναι στα πόδια:□+6 πανοπλία□+3 ανθεκτικότητα πανοπλίας□+1 αντίσταση απώθησης",
  "item.minecraft.netherite_boots": "μπότες νεδερίτη□□όταν είναι στις πατούσες:□+3 πανοπλία□+3 ανθεκτικότητα πανοπλίας□+1 αντίσταση απώθησης",
  "item.minecraft.flint": "πυρόλιθος",
  "item.minecraft.porkchop": "ωμό χοιρινό",
  "item.minecraft.cooked_porkchop": "μαγειρεμένο χοιρινό",
  "item.minecraft.painting": "πίνακας",
  "item.minecraft.golden_apple": "χρυσό μήλο",
  "item.minecraft.enchanted_golden_apple": "μαγεμένο χρυσό μήλο",
  "block.minecraft.oak_sign": "πινακίδα βελανιδιάς",
  "block.minecraft.spruce_sign": "πινακίδα ελάτου",
  "block.minecraft.birch_sign": "πινακίδα σημύδας",
  "block.minecraft.jungle_sign": "πινακίδα ζούγκλας",
  "block.minecraft.acacia_sign": "πινακίδα ακακίας",
  "block.minecraft.dark_oak_sign": "πινακίδα σκούρας βελανιδιάς",
  "block.minecraft.crimson_sign": "ερυθρή πινακίδα",
  "block.minecraft.warped_sign": "διαστρεβλωμένη πινακίδα",
  "item.minecraft.bucket": "κουβάς",
  "item.minecraft.water_bucket": "κουβάς νερού",
  "item.minecraft.lava_bucket": "κουβάς λάβας",
  "item.minecraft.minecart": "βαγονέτο",
  "item.minecraft.saddle": "σέλα",
  "item.minecraft.redstone": "σκόνη ρέντστοουν",
  "item.minecraft.snowball": "χιονόμπαλα",
  "item.minecraft.oak_boat": "βάρκα βελανιδιάς",
  "item.minecraft.leather": "δέρμα",
  "item.minecraft.milk_bucket": "κουβάς γάλακτος",
  "item.minecraft.pufferfish_bucket": "κουβάς με ψάρι φούσκα",
  "item.minecraft.salmon_bucket": "κουβάς με σολομό",
  "item.minecraft.cod_bucket": "κουβάς με μπακαλιάρο",
  "item.minecraft.tropical_fish_bucket": "κουβάς με τροπικό ψάρι",
  "item.minecraft.brick": "τούβλο",
  "item.minecraft.clay_ball": "μπάλα πηλού",
  "block.minecraft.dried_kelp_block": "κύβος αποξηραμένων φυκιών",
  "item.minecraft.paper": "χαρτί",
  "item.minecraft.book": "βιβλίο",
  "item.minecraft.slime_ball": "μπάλα γλίτσας",
  "item.minecraft.chest_minecart": "βαγονέτο με σεντούκι",
  "item.minecraft.furnace_minecart": "βαγονέτο με φούρνο",
  "item.minecraft.egg": "αβγό",
  "item.minecraft.compass": "πυξίδα",
  "item.minecraft.fishing_rod": "καλάμι ψαρέματος",
  "item.minecraft.clock": "ρολόι",
  "item.minecraft.glowstone_dust": "σκόνη λαμψόπετρας",
  "item.minecraft.cod": "ωμός μπακαλιάρος",
  "item.minecraft.salmon": "ωμός σολομός",
  "item.minecraft.tropical_fish": "τροπικό ψάρι",
  "item.minecraft.pufferfish": "ψάρι φούσκα",
  "item.minecraft.cooked_cod": "μαγειρεμένος μπακαλιάρος",
  "item.minecraft.cooked_salmon": "μαγειρεμένος σολομός",
  "item.minecraft.ink_sac": "θύλακας μελανιού",
  "item.minecraft.red_dye": "κόκκινη βαφή",
  "item.minecraft.green_dye": "πράσινη βαφή",
  "item.minecraft.cocoa_beans": "σπόροι κακάο",
  "item.minecraft.lapis_lazuli": "λάπις λάζουλι",
  "item.minecraft.purple_dye": "μοβ βαφή",
  "item.minecraft.cyan_dye": "κυανή βαφή",
  "item.minecraft.light_gray_dye": "ανοιχτή γκρίζα βαφή",
  "item.minecraft.gray_dye": "γκρίζα βαφή",
  "item.minecraft.pink_dye": "ροζ βαφή",
  "item.minecraft.lime_dye": "λαχανί βαφή",
  "item.minecraft.yellow_dye": "κίτρινη βαφή",
  "item.minecraft.light_blue_dye": "γαλάζια βαφή",
  "item.minecraft.magenta_dye": "φούξια βαφή",
  "item.minecraft.orange_dye": "πορτοκαλί βαφή",
  "item.minecraft.bone_meal": "οστεάλευρο",
  "item.minecraft.blue_dye": "μπλε βαφή",
  "item.minecraft.brown_dye": "καφέ βαφή",
  "item.minecraft.black_dye": "μαύρη βαφή",
  "item.minecraft.white_dye": "λευκή βαφή",
  "item.minecraft.bone": "οστό",
  "item.minecraft.sugar": "ζάχαρη",
  "block.minecraft.cake": "τούρτα",
  "block.minecraft.white_bed": "λευκό κρεβάτι",
  "block.minecraft.orange_bed": "πορτοκαλί κρεβάτι",
  "block.minecraft.magenta_bed": "φούξια κρεβάτι",
  "block.minecraft.light_blue_bed": "γαλάζιο κρεβάτι",
  "block.minecraft.yellow_bed": "κίτρινο κρεβάτι",
  "block.minecraft.lime_bed": "λαχανί κρεβάτι",
  "block.minecraft.pink_bed": "ροζ κρεβάτι",
  "block.minecraft.gray_bed": "γκρίζο κρεβάτι",
  "block.minecraft.light_gray_bed": "ανοιχτό γκρίζο κρεβάτι",
  "block.minecraft.cyan_bed": "κυανό κρεβάτι",
  "block.minecraft.purple_bed": "μοβ κρεβάτι",
  "block.minecraft.blue_bed": "μπλε κρεβάτι",
  "block.minecraft.brown_bed": "καφέ κρεβάτι",
  "block.minecraft.green_bed": "πράσινο κρεβάτι",
  "block.minecraft.red_bed": "κόκκινο κρεβάτι",
  "block.minecraft.black_bed": "μαύρο κρεβάτι",
  "item.minecraft.cookie": "μπισκότο",
  "item.minecraft.filled_map": "χάρτης□#0",
  "item.minecraft.shears": "ψαλίδα",
  "item.minecraft.melon_slice": "φέτα καρπουζιού",
  "item.minecraft.dried_kelp": "αποξηραμένα φύκια",
  "item.minecraft.pumpkin_seeds": "σπόροι κολοκύθας",
  "item.minecraft.melon_seeds": "σπόροι καρπουζιού",
  "item.minecraft.beef": "ωμό βοδινό",
  "item.minecraft.cooked_beef": "μαγειρεμένο βοδινό",
  "item.minecraft.chicken": "ωμό κοτόπουλο",
  "item.minecraft.cooked_chicken": "μαγειρεμένο κοτόπουλο",
  "item.minecraft.rotten_flesh": "σάπια σάρκα",
  "item.minecraft.ender_pearl": "μαργαριτάρι έντερ",
  "item.minecraft.blaze_rod": "ράβδος πυροστρόβιλου",
  "item.minecraft.ghast_tear": "δάκρυ γκαστ",
  "item.minecraft.gold_nugget": "σβώλος χρυσού",
  "item.minecraft.nether_wart": "στίγμα νέδερ",
  "item.minecraft.potion": "μη κατασκευάσιμο φίλτρο□καμία επίδραση",
  "item.minecraft.glass_bottle": "γυάλινο μπουκάλι",
  "item.minecraft.spider_eye": "μάτι αράχνης",
  "item.minecraft.fermented_spider_eye": "ζυμωμένο μάτι αράχνης",
  "item.minecraft.blaze_powder": "σκόνη πυροστρόβιλου",
  "item.minecraft.magma_cream": "κρέμα μάγματος",
  "block.minecraft.brewing_stand": "πάγκος παρασκευής",
  "block.minecraft.cauldron": "καζάνι",
  "item.minecraft.ender_eye": "μάτι του έντερ",
  "item.minecraft.glistering_melon_slice": "αστραφτερή φέτα καρπουζιού",
  "item.minecraft.bat_spawn_egg": "αβγό γέννησης νυχτερίδας",
  "item.minecraft.bee_spawn_egg": "αβγό γέννησης μέλισσας",
  "item.minecraft.blaze_spawn_egg": "αβγό γέννησης πυροστρόβιλου",
  "item.minecraft.cat_spawn_egg": "αβγό γέννησης γάτας",
  "item.minecraft.cave_spider_spawn_egg": "αβγό γέννησης αράχνης σπηλιάς",
  "item.minecraft.chicken_spawn_egg": "αβγό γέννησης κότας",
  "item.minecraft.cod_spawn_egg": "αβγό γέννησης μπακαλιάρου",
  "item.minecraft.cow_spawn_egg": "αβγό γέννησης αγελάδας",
  "item.minecraft.creeper_spawn_egg": "αβγό γέννησης κρίπερ",
  "item.minecraft.dolphin_spawn_egg": "αβγό γέννησης δελφινιού",
  "item.minecraft.donkey_spawn_egg": "αβγό γέννησης γαϊδάρου",
  "item.minecraft.drowned_spawn_egg": "αβγό γέννησης πνιγμένου",
  "item.minecraft.elder_guardian_spawn_egg": "αβγό γέννησης πρεσβύτερου φρουρού",
  "item.minecraft.enderman_spawn_egg": "αβγό γέννησης έντερμαν",
  "item.minecraft.endermite_spawn_egg": "αβγό γέννησης εντερμίτη",
  "item.minecraft.evoker_spawn_egg": "αβγό γέννησης επικαλεστή",
  "item.minecraft.fox_spawn_egg": "αβγό γέννησης αλεπούς",
  "item.minecraft.ghast_spawn_egg": "αβγό γέννησης γκαστ",
  "item.minecraft.guardian_spawn_egg": "αβγό γέννησης φρουρού",
  "item.minecraft.hoglin_spawn_egg": "αβγό γέννησης χόγκλιν",
  "item.minecraft.horse_spawn_egg": "αβγό γέννησης αλόγου",
  "item.minecraft.husk_spawn_egg": "αβγό γέννησης αφυδατωμένου",
  "item.minecraft.llama_spawn_egg": "αβγό γέννησης λάμα",
  "item.minecraft.magma_cube_spawn_egg": "αβγό γέννησης κύβου μάγματος",
  "item.minecraft.mooshroom_spawn_egg": "αβγό γέννησης μούσρουμ",
  "item.minecraft.mule_spawn_egg": "αβγό γέννησης μουλαριού",
  "item.minecraft.ocelot_spawn_egg": "αβγό γέννησης οσελότου",
  "item.minecraft.panda_spawn_egg": "αβγό γέννησης πάντα",
  "item.minecraft.parrot_spawn_egg": "αβγό γέννησης παπαγάλου",
  "item.minecraft.phantom_spawn_egg": "αβγό γέννησης φαντάσματος",
  "item.minecraft.pig_spawn_egg": "αβγό γέννησης γουρουνιού",
  "item.minecraft.piglin_spawn_egg": "αβγό γέννησης πίγκλιν",
  "item.minecraft.pillager_spawn_egg": "αβγό γέννησης λεηλάτη",
  "item.minecraft.polar_bear_spawn_egg": "αβγό γέννησης πολικής αρκούδας",
  "item.minecraft.pufferfish_spawn_egg": "αβγό γέννησης ψαριού φούσκας",
  "item.minecraft.rabbit_spawn_egg": "αβγό γέννησης κουνελιού",
  "item.minecraft.ravager_spawn_egg": "αβγό γέννησης αφανιστή",
  "item.minecraft.salmon_spawn_egg": "αβγό γέννησης σολομού",
  "item.minecraft.sheep_spawn_egg": "αβγό γέννησης προβάτου",
  "item.minecraft.shulker_spawn_egg": "αβγό γέννησης σάλκερ",
  "item.minecraft.silverfish_spawn_egg": "αβγό γέννησης ασημόψαρου",
  "item.minecraft.skeleton_spawn_egg": "αβγό γέννησης σκελετού",
  "item.minecraft.skeleton_horse_spawn_egg": "αβγό γέννησης αλόγου σκελετού",
  "item.minecraft.slime_spawn_egg": "αβγό γέννησης γλίτσας",
  "item.minecraft.spider_spawn_egg": "αβγό γέννησης αράχνης",
  "item.minecraft.squid_spawn_egg": "αβγό γέννησης καλαμαριού",
  "item.minecraft.stray_spawn_egg": "αβγό γέννησης περιπλανώμενου",
  "item.minecraft.strider_spawn_egg": "αβγό γέννησης δρασκελιά",
  "item.minecraft.trader_llama_spawn_egg": "αβγό γέννησης λάμα εμπόρου",
  "item.minecraft.tropical_fish_spawn_egg": "αβγό γέννησης τροπικού ψαριού",
  "item.minecraft.turtle_spawn_egg": "αβγό γέννησης χελώνας",
  "item.minecraft.vex_spawn_egg": "αβγό γέννησης διαταράκτη",
  "item.minecraft.villager_spawn_egg": "αβγό γέννησης χωρικού",
  "item.minecraft.vindicator_spawn_egg": "αβγό γέννησης εξιλεωτή",
  "item.minecraft.wandering_trader_spawn_egg": "αβγό γέννησης περιπλανώμενου εμπόρου",
  "item.minecraft.witch_spawn_egg": "αβγό γέννησης μάγισσας",
  "item.minecraft.wither_skeleton_spawn_egg": "αβγό γέννησης σκελετού ουίδερ",
  "item.minecraft.wolf_spawn_egg": "αβγό γέννησης λύκου",
  "item.minecraft.zoglin_spawn_egg": "αβγό γέννησης ζόγκλιν",
  "item.minecraft.zombie_spawn_egg": "αβγό γέννησης ζόμπι",
  "item.minecraft.zombie_horse_spawn_egg": "αβγό γέννησης αλόγου ζόμπι",
  "item.minecraft.zombie_villager_spawn_egg": "αβγό γέννησης χωρικού ζόμπι",
  "item.minecraft.zombified_piglin_spawn_egg": "αβγό γέννησης πίγκλιν ζόμπι",
  "item.minecraft.experience_bottle": "μπουκάλι μαγέματος",
  "item.minecraft.fire_charge": "καψούλι φωτιάς",
  "item.minecraft.writable_book": "βιβλίο και πένα",
  "item.minecraft.written_book": "γραμμένο βιβλίο",
  "item.minecraft.emerald": "σμαράγδι",
  "item.minecraft.item_frame": "κορνίζα αντικειμένου",
  "block.minecraft.flower_pot": "γλάστρα",
  "item.minecraft.carrot": "καρότο",
  "item.minecraft.potato": "πατάτα",
  "item.minecraft.baked_potato": "ψημένη πατάτα",
  "item.minecraft.poisonous_potato": "δηλητηριώδης πατάτα",
  "item.minecraft.map": "κενός χάρτης",
  "item.minecraft.golden_carrot": "χρυσό καρότο",
  "block.minecraft.skeleton_skull": "κρανίο σκελετού",
  "block.minecraft.wither_skeleton_skull": "κρανίο σκελετού ουίδερ",
  "block.minecraft.player_head": "κεφάλι παίκτη",
  "block.minecraft.zombie_head": "κεφάλι ζόμπι",
  "block.minecraft.creeper_head": "κεφάλι κρίπερ",
  "block.minecraft.dragon_head": "κεφάλι δράκου",
  "item.minecraft.carrot_on_a_stick": "καρότο σε ξυλάκι",
  "item.minecraft.warped_fungus_on_a_stick": "διαστρεβλωμένος μύκητας σε ξυλάκι",
  "item.minecraft.nether_star": "αστέρι νέδερ",
  "item.minecraft.pumpkin_pie": "κολοκυθόπιτα",
  "item.minecraft.firework_rocket": "ρουκέτα πυροτεχνήματος",
  "item.minecraft.firework_star": "πυροκροτητής πυροτεχνήματος",
  "item.minecraft.enchanted_book": "μαγεμένο βιβλίο",
  "item.minecraft.nether_brick": "τούβλο νέδερ",
  "item.minecraft.quartz": "χαλαζίας νέδερ",
  "item.minecraft.tnt_minecart": "βαγονέτο με tnt",
  "item.minecraft.hopper_minecart": "βαγονέτο με χοάνη",
  "item.minecraft.prismarine_shard": "θραύσμα πρισμαρίνης",
  "item.minecraft.prismarine_crystals": "κρύσταλλοι πρισμαρίνης",
  "item.minecraft.rabbit": "ωμό κρέας κουνελιού",
  "item.minecraft.cooked_rabbit": "μαγειρεμένο κρέας κουνελιού",
  "item.minecraft.rabbit_stew": "κουνέλι στιφάδο",
  "item.minecraft.rabbit_foot": "λαγοπόδαρο",
  "item.minecraft.rabbit_hide": "δέρμα κουνελιού",
  "item.minecraft.armor_stand": "πάγκος πανοπλίας",
  "item.minecraft.iron_horse_armor": "σιδερένια πανοπλία αλόγου",
  "item.minecraft.golden_horse_armor": "χρυσή πανοπλία αλόγου",
  "item.minecraft.diamond_horse_armor": "διαμαντένια πανοπλία αλόγου",
  "item.minecraft.leather_horse_armor": "δερμάτινη πανοπλία αλόγου",
  "item.minecraft.lead": "λουρί",
  "item.minecraft.name_tag": "ετικέτα ονόματος",
  "item.minecraft.command_block_minecart": "βαγονέτο με κύβο εντολής",
  "item.minecraft.mutton": "ωμό πρόβειο κρέας",
  "item.minecraft.cooked_mutton": "μαγειρεμένο πρόβειο κρέας",
  "block.minecraft.white_banner": "λευκό λάβαρο",
  "block.minecraft.orange_banner": "πορτοκαλί λάβαρο",
  "block.minecraft.magenta_banner": "φούξια λάβαρο",
  "block.minecraft.light_blue_banner": "γαλάζιο λάβαρο",
  "block.minecraft.yellow_banner": "κίτρινο λάβαρο",
  "block.minecraft.lime_banner": "λαχανί λάβαρο",
  "block.minecraft.pink_banner": "ροζ λάβαρο",
  "block.minecraft.gray_banner": "γκρίζο λάβαρο",
  "block.minecraft.light_gray_banner": "ανοιχτό γκρίζο λάβαρο",
  "block.minecraft.cyan_banner": "κυανό λάβαρο",
  "block.minecraft.purple_banner": "μοβ λάβαρο",
  "block.minecraft.blue_banner": "μπλε λάβαρο",
  "block.minecraft.brown_banner": "καφέ λάβαρο",
  "block.minecraft.green_banner": "πράσινο λάβαρο",
  "block.minecraft.red_banner": "κόκκινο λάβαρο",
  "block.minecraft.black_banner": "μαύρο λάβαρο",
  "item.minecraft.end_crystal": "κρύσταλλος εντ",
  "item.minecraft.chorus_fruit": "χορικό φρούτο",
  "item.minecraft.popped_chorus_fruit": "σκασμένο χορικό φρούτο",
  "item.minecraft.beetroot": "παντζάρι",
  "item.minecraft.beetroot_seeds": "σπόροι παντζαριού",
  "item.minecraft.beetroot_soup": "σούπα παντζαριού",
  "item.minecraft.dragon_breath": "ανάσα δράκου",
  "item.minecraft.splash_potion": "μη κατασκευάσιμο φίλτρο πιτσιλιάς□καμία επίδραση",
  "item.minecraft.spectral_arrow": "λαμπερό βέλος",
  "item.minecraft.tipped_arrow": "μη κατασκευάσιμο εμποτισμένο βέλος□καμία επίδραση",
  "item.minecraft.lingering_potion": "μη κατασκευάσιμο φίλτρο διαρκείας□καμία επίδραση",
  "item.minecraft.shield": "ασπίδα",
  "item.minecraft.elytra": "έλυτρα",
  "item.minecraft.spruce_boat": "βάρκα ελάτου",
  "item.minecraft.birch_boat": "βάρκα σημύδας",
  "item.minecraft.jungle_boat": "βάρκα ζούγκλας",
  "item.minecraft.acacia_boat": "βάρκα ακακίας",
  "item.minecraft.dark_oak_boat": "βάρκα σκούρας βελανιδιάς",
  "item.minecraft.totem_of_undying": "τοτέμ της αθανασίας",
  "item.minecraft.shulker_shell": "κέλυφος σάλκερ",
  "item.minecraft.iron_nugget": "σβώλος σιδήρου",
  "item.minecraft.knowledge_book": "βιβλίο γνώσεων",
  "item.minecraft.debug_stick": "ραβδί αποσφαλμάτωσης",
  "item.minecraft.music_disc_13": "μουσικός δίσκος□c418 - 13",
  "item.minecraft.music_disc_cat": "μουσικός δίσκος□c418 - cat",
  "item.minecraft.music_disc_blocks": "μουσικός δίσκος□c418 - blocks",
  "item.minecraft.music_disc_chirp": "μουσικός δίσκος□c418 - chirp",
  "item.minecraft.music_disc_far": "μουσικός δίσκος□c418 - far",
  "item.minecraft.music_disc_mall": "μουσικός δίσκος□c418 - mall",
  "item.minecraft.music_disc_mellohi": "μουσικός δίσκος□c418 - mellohi",
  "item.minecraft.music_disc_stal": "μουσικός δίσκος□c418 - stal",
  "item.minecraft.music_disc_strad": "μουσικός δίσκος□c418 - strad",
  "item.minecraft.music_disc_ward": "μουσικός δίσκος□c418 - ward",
  "item.minecraft.music_disc_11": "μουσικός δίσκος□c418 - 11",
  "item.minecraft.music_disc_wait": "μουσικός δίσκος□c418 - wait",
  "item.minecraft.music_disc_pigstep": "μουσικός δίσκος□λένα ρέιν - pigstep",
  "item.minecraft.trident": "τρίαινα□□όταν είναι στο κύριο χέρι:□+8 ζημιά επίθεσης□-2.9 ταχύτητα επίθεσης",
  "item.minecraft.phantom_membrane": "μεμβράνη φαντάσματος",
  "item.minecraft.nautilus_shell": "όστρακο ναυτίλου",
  "item.minecraft.heart_of_the_sea": "καρδιά της θάλασσας",
  "item.minecraft.crossbow": "βαλλίστρα",
  "item.minecraft.suspicious_stew": "ύποπτο στιφάδο",
  "block.minecraft.loom": "αργαλειός",
  "item.minecraft.flower_banner_pattern": "σχέδιο λάβαρου□σήμα άνθους",
  "item.minecraft.creeper_banner_pattern": "σχέδιο λάβαρου□σήμα κρίπερ",
  "item.minecraft.skull_banner_pattern": "σχέδιο λάβαρου□σήμα κρανίου",
  "item.minecraft.mojang_banner_pattern": "σχέδιο λάβαρου□πράγμα",
  "item.minecraft.globe_banner_pattern": "σχέδιο λάβαρου□υδρόγειος",
  "item.minecraft.piglin_banner_pattern": "σχέδιο λάβαρου□μουσούδα",
  "block.minecraft.composter": "κομποστοποιητής",
  "block.minecraft.barrel": "βαρέλι",
  "block.minecraft.smoker": "καπνιστήρι",
  "block.minecraft.blast_furnace": "υψικάμινος",
  "block.minecraft.cartography_table": "τραπέζι χαρτογραφίας",
  "block.minecraft.fletching_table": "τραπέζι κατασκευής βελών",
  "block.minecraft.grindstone": "ακονόπετρα",
  "block.minecraft.lectern": "αναλόγιο",
  "block.minecraft.smithing_table": "τραπέζι μεταλλουργίας",
  "block.minecraft.stonecutter": "πετροκόπτης",
  "block.minecraft.bell": "καμπάνα",
  "block.minecraft.lantern": "φανάρι",
  "block.minecraft.soul_lantern": "φανάρι ψυχών",
  "item.minecraft.sweet_berries": "γλυκά μούρα",
  "block.minecraft.campfire": "φωτιά κατασκήνωσης",
  "block.minecraft.soul_campfire": "φωτιά κατασκήνωσης ψυχών",
  "block.minecraft.shroomlight": "μανιταρόφως",
  "item.minecraft.honeycomb": "κηρήθρα",
  "block.minecraft.bee_nest": "μελισσοφωλιά",
  "block.minecraft.beehive": "κυψέλη",
  "item.minecraft.honey_bottle": "μπουκάλι μελιού",
  "block.minecraft.honey_block": "κύβος μελιού",
  "block.minecraft.honeycomb_block": "κύβος κηρήθρας",
  "block.minecraft.lodestone": "μαγνητίτης",
  "block.minecraft.netherite_block": "κύβος νεδερίτη",
  "block.minecraft.ancient_debris": "αρχαία συντρίμμια",
  "block.minecraft.target": "στόχος",
  "block.minecraft.crying_obsidian": "δακρυσμένος οψιδιανός",
  "block.minecraft.blackstone": "μαυρόπετρα",
  "block.minecraft.blackstone_slab": "πλάκα μαυρόπετρας",
  "block.minecraft.blackstone_stairs": "σκάλες μαυρόπετρας",
  "block.minecraft.gilded_blackstone": "επιχρυσωμένη μαυρόπετρα",
  "block.minecraft.polished_blackstone": "γυαλισμένη μαυρόπετρα",
  "block.minecraft.polished_blackstone_slab": "πλάκα γυαλισμένης μαυρόπετρας",
  "block.minecraft.polished_blackstone_stairs": "σκάλες γυαλισμένης μαυρόπετρας",
  "block.minecraft.chiseled_polished_blackstone": "λαξευμένη γυαλισμένη μαυρόπετρα",
  "block.minecraft.polished_blackstone_bricks": "γυαλισμένα τούβλα μαυρόπετρας",
  "block.minecraft.polished_blackstone_brick_slab": "πλάκα γυαλισμένων τούβλων μαυρόπετρας",
  "block.minecraft.polished_blackstone_brick_stairs": "σκάλες γυαλισμένων τούβλων μαυρόπετρας",
  "block.minecraft.cracked_polished_blackstone_bricks": "ραγισμένα γυαλισμένα τούβλα μαυρόπετρας",
  "block.minecraft.respawn_anchor": "άγκυρα αναγέννησης",
}
export const el_gr = items; 
